export default __webpack_public_path__ + "static/media/support-notes-main-infobae.455cc1f0.png";